const styles = () => ({
    alertContainer: {
        overflow: 'hidden',
        paddingBottom: '20px',
        '& h3': {
            fontWeight: 'bold',
            color: '#666',
            marginBottom: '5px',
        },
        '& p': {
            margin: '0',
        },
    },
    alertButtonContainer: {
        marginTop: '20px',
    },
    alertButtonCta: {
        padding: '10px 15px',
        marginRight: '10px',
    },
});

export default styles;
